import { render } from "./DocCategoryCard.vue?vue&type=template&id=6e19d64c&scoped=true"
import script from "./DocCategoryCard.vue?vue&type=script&lang=js"
export * from "./DocCategoryCard.vue?vue&type=script&lang=js"

import "./DocCategoryCard.vue?vue&type=style&index=0&id=6e19d64c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e19d64c"]])

export default __exports__